import Vue from 'vue'
require('./http.js')
/**
 * 失败操作提示
 */
Vue.prototype.error = function (param) {
  let msg = '操作失败'
  if (param) {
    msg = param
  }
  this.$message({
    type: 'error',
    message: msg
  })
}
/**
 * 成功操作提示
 */
Vue.prototype.success = function (param) {
  let msg = '操作成功'
  if (param) {
    msg = param
  }
  this.$message({
    type: 'success',
    message: msg
  })
}
/**
 * 确认弹框
 * @title [string] 确认弹框标题
 * @content [string] 确认信息
 * @callback [function] 确认后回调方法
 */
Vue.prototype.confirm = function (title, content, callback) {
  let t = '删除提示'
  let c = '此操作将永久删除该文件, 是否继续?'
  if (title) {
    t = title
  }
  if (content) {
    c = content
  }
  this.$confirm(c, t, {
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    callback()
  }).catch(() => {})
}
/**
 * 路由跳转
 * @param [string] 路由
 * @return [null]
 */
Vue.prototype.r = function (param) {
  this.$router.push(param, () => {})
}
/**
 * 打印参数
 * @param [string] 路由
 * @return [null]
 */
Vue.prototype.p = function (param) {
  console.log(param)
}

/**
 * 获取窗口屏幕高度
 * @param string 需要获取的名称
 * @return number
 */
Vue.prototype.size = function (param) {
  let res = ''
  if (param) {
    switch (param) {
      case 'innerWidth':
        res = window.innerWidth
        break
      case 'innerHeight':
        res = window.innerHeight
        break
      case 'screenWidth':
        res = window.screen.width
        break
      case 'screenHeight':
        res = window.screenHeight
        break
    }
  }
  return res
}



// WEBPACK FOOTER //
// ./src/utils/common.js